"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactCountdown = _interopRequireDefault(require("react-countdown"));
var Completionist = function Completionist() {
  return /*#__PURE__*/_react["default"].createElement("p", {
    className: "x-lg-font d8-u-color-white"
  }, /*#__PURE__*/_react["default"].createElement("strong", null, "Bookings are open!"));
};
var defaultRenderer = function defaultRenderer(_ref) {
  var days = _ref.days,
    hours = _ref.hours,
    minutes = _ref.minutes,
    seconds = _ref.seconds,
    completed = _ref.completed;
  if (completed) {
    return /*#__PURE__*/_react["default"].createElement(Completionist, null);
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex d8-u-color-white flex-gap-md"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: ""
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "s-font upper-title"
  }, "Days"), /*#__PURE__*/_react["default"].createElement("strong", {
    className: "x-lg-font"
  }, days)), /*#__PURE__*/_react["default"].createElement("div", {
    className: ""
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "s-font upper-title"
  }, "Hours"), /*#__PURE__*/_react["default"].createElement("strong", {
    className: "x-lg-font"
  }, hours)), /*#__PURE__*/_react["default"].createElement("div", {
    className: ""
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "s-font upper-title"
  }, "Mins"), /*#__PURE__*/_react["default"].createElement("strong", {
    className: "x-lg-font"
  }, minutes)), /*#__PURE__*/_react["default"].createElement("div", {
    className: ""
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "s-font upper-title"
  }, "Secs"), /*#__PURE__*/_react["default"].createElement("strong", {
    className: "x-lg-font"
  }, seconds)));
};
defaultRenderer.propTypes = {
  days: _propTypes["default"].string,
  hours: _propTypes["default"].string,
  minutes: _propTypes["default"].string,
  seconds: _propTypes["default"].string,
  completed: _propTypes["default"].bool
};
var ReactCountdown = function ReactCountdown(_ref2) {
  var countdown = _ref2.countdown,
    renderer = _ref2.renderer;
  return /*#__PURE__*/_react["default"].createElement(_reactCountdown["default"], {
    date: countdown,
    renderer: renderer || defaultRenderer
  });
};
ReactCountdown.propTypes = {
  countdown: _propTypes["default"].string,
  renderer: _propTypes["default"].func
};
var _default = exports["default"] = ReactCountdown;